/* eslint-disable dot-notation */
/* eslint-disable no-restricted-syntax */

import { Controller } from 'stimulus';

const reviewInputFields = [
  'rating',
  'title',
  'review',
  'name',
  'email',
  'pro',
  'corn',
  'will_you_recommend',
];

export default class extends Controller {
  static targets = [
    'errors',
    'success',
    'review',
    'treatment',
    'title',
    'titleCount',
    'reviewCount',
    'treatmentCount',
    'form',
  ];

  initialize() {
    this.titleCharCount();
    this.reviewCharCount();
    this.treatmentCharCount();
  }

  success(event) {
    const [data, status, xhr] = event.detail;
    this.successTarget.innerHTML = xhr.response;
    this.errorsTarget.innerHTML = '';
  }

  errorHandler(event) {
    const [data, status, xhr] = event.detail;
    const errors = JSON.parse(xhr.response);

    this.showErrors(errors['messages'] || {});
    console.log(errors['messages']);
    // this.errorsTarget.innerHTML = xhr.response;
  }

  titleCharCount() {
    const maxLen = 120;
    if (this.titleTarget.value.length > maxLen) {
      this.titleTarget.value = this.titleTarget.value.substr(0, maxLen);
    }
    const charLeft = maxLen - this.titleTarget.value.length;
    this.titleCountTarget.textContent = charLeft;
  }

  reviewCharCount() {
    const maxLen = 2000;
    if (this.reviewTarget.value.length > maxLen) {
      this.reviewTarget.value = this.reviewTarget.value.substr(0, maxLen);
    }
    const charLeft = maxLen - this.reviewTarget.value.length;
    this.reviewCountTarget.textContent = charLeft;
  }

  treatmentCharCount() {
    const maxLen = 2000;
    if (this.treatmentTarget.value.length > maxLen) {
      this.treatmentTarget.value = this.treatmentTarget.value.substr(0, maxLen);
    }
    const charLeft = maxLen - this.treatmentTarget.value.length;
    this.treatmentCountTarget.textContent = charLeft;
  }

  showErrors(errors) {
    for (const input of reviewInputFields) {
      if (errors[input]) {
        document.getElementById(`error_review_${input}`).textContent =
          errors[input];
      } else {
        document.getElementById(`error_review_${input}`).textContent = '';
      }
    }
  }
}
